import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import store, { history } from './store';
import App from './containers/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import lodashThrottle from 'lodash.throttle';
import { saveState } from './store/localStorage';

if (process.env.NODE_ENV !== 'production') {
  require('./apiStub');
}

const target = document.querySelector('#root');

store.subscribe(
  lodashThrottle(() => {
    const storeContent = store.getState().activeStore;
    saveState({
      stores: store.getState().stores,
      storeContent
    });
  }, 1000)
);

const renderApp = Component =>
  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <Component />
        </div>
      </ConnectedRouter>
    </Provider>,
    target
  );

renderApp(App);

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept('./containers/App', () => {
      const NextApp = require('./containers/App').default;
      renderApp(NextApp);
    });
  }
}



// WEBPACK FOOTER //
// ./src/index.js